import { Box, Typography } from "@material-ui/core";
import React from "react";

import {
  InvestmentStyleDiagnosisRequestMonthlyOutOfPocketEnum as MonthlyEnum,
} from "@/api/generated";
import {
  DIAGNOSIS_QUESTION_TEXT,
  MONTHLY_OPTIONS,
} from "@/constants/investmentStyleDiagnosisQuestions";

import { DiagnosisInvestmentStyleCheckboxList } from "../DiagnosisInvestmentStyleCheckboxList";

import { useStepStyles } from "./stepStyles";

type MonthlyStepProps = {
  monthlyOutOfPocket: MonthlyEnum | null;
  onMonthlyOutOfPocketChange: (next: MonthlyEnum | null) => void;
};

const MonthlyStep: React.FC<MonthlyStepProps> = ({
  monthlyOutOfPocket,
  onMonthlyOutOfPocketChange,
}) => {
  const classes = useStepStyles();
  return (
    <>
      <Typography className={classes.title}>毎月の自己負担について</Typography>
      <Typography className={classes.description}>{DIAGNOSIS_QUESTION_TEXT[5]}</Typography>
      <Box className={classes.notice}>
        <Typography className={classes.noticeText}>
          現時点で無理なく続けられる上限に最も近い金額をお選びください
        </Typography>
      </Box>
      <Box className={classes.inputArea}>
        <DiagnosisInvestmentStyleCheckboxList
          options={MONTHLY_OPTIONS}
          selected={monthlyOutOfPocket ? [monthlyOutOfPocket] : []}
          single
          onChange={(next) => onMonthlyOutOfPocketChange(next[0] ?? null)}
        />
      </Box>
    </>
  );
};

export default MonthlyStep;
